<template>
    <div>
        <div @click="dialogVisible = true" class="upload-kyb">
            <div class="icon-name">
                <img :src="iconObj.icon" alt="" />
                {{iconObj.title}}
            </div>
            <span>我是供应商 需要上传产品</span>
        </div>
        
        <el-dialog
            :visible.sync="dialogVisible"
            :append-to-body="true"
            width="470px"
            class="use-kyb-dialog">
            <p class="text-content">如果您企业的工业产品（整机装备或者零部件），希望上传到“{{appNameLabel}}”选型平台，供全国广大设计（采购）工程师选用，请直接下载上传工具及相关教程。</p>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" type="primary" @click="_downZip">下载{{iconObj.title}}及操作说明</el-button>
                <!-- <el-button size="medium" type="primary" @click="_downZip">下载使用帮助</el-button> -->
                <el-button size="medium" @click="_goChat">联系服务专员</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {WinForm,CheckLibs,AppName} from '@digital-supply-chain/module'
    import { ChatService } from '@/service';
    import { Category, ApiService } from '@/libs';

  export default {
    data() {
      return {
        dialogVisible: false,
        appNameLabel: (WinForm.md.getAppNameLabel() || '大工程师').replace('企业版', ''),
      };
    },
    computed: {
        iconObj() {
            let icon = `${DomainService.PublicPath}resource/images/icon/kyb.png`;
            let title = '客元宝';
            if (CheckLibs.isGreatCraftsman() || CheckLibs.isGreatCraftsmanEnt()) {
                icon = `${DomainService.PublicPath}resource/images/icon/great-im.png`;
                title = '大国智造'
            }
            return { icon, title }
        }
    },
    methods: {
        _goChat() {
            this.dialogVisible = false;
            ChatService.StartRecent(Category.User, 817)
        },
        _downZip() {
            if (WinForm.md.getAppName() != AppName.BigEngineer && WinForm.md.getAppName() != AppName.BigEngineerE) {
                WinForm.md.openUrl('https://down.global-dsc.cn/Release/dgzz/dgzz.exe');
                return false;
            }
            // WinForm.md.openUrl(`${ApiService.OssHzHost}/kyb/客元宝介绍与帮助.zip`);
            WinForm.md.openUrl('https://kyb-pack.oss-cn-hangzhou.aliyuncs.com/Release/kyb/KYBmanual.zip');
        }
    }
  };
</script>

<style lang="less" scoped>
    .use-kyb-dialog{
        .text-content{
            font-size: 16px;
            line-height: 30px;
        }
        /deep/ .el-dialog{
            background: #ecf5ff;
            border: 1px solid #b3d8ff;
            border-radius: 28px;
        }
        /deep/ .el-dialog__header{
            padding: 0;
        }
        /deep/ .el-dialog__body{
            padding-bottom: 0;
        }
    }
    .upload-kyb{
        position: absolute;
        right: -72px;
        top: 0;
        font-size: 12px;
        color: #0989C5;
        line-height: 18px;
        color: #0989c5;
        z-index: 1000;
        cursor: pointer;
        outline: none;
        text-align: center;
        img{
            width: 30px;
            height: 30px;
            position: absolute;
            left: 0;
            top: 0;
        }
        .icon-name{
            width: 120px;
            line-height: 30px;
            color: #dc0000;
            font-size: 20px;
            font-weight: bold;
            padding-left: 36px;
            margin: 0 auto;
            margin-bottom: 4px;
            position: relative;
        }
    }
    .dialog-footer{
        text-align: center;
        width: 100%;
        display: block;
    }
</style>
